import { useUIStore } from '@/store/app-store'

export function useToast() {
  const { addNotification } = useUIStore()

  const toast = (notification: {
    title: string
    message: string
    type?: 'info' | 'success' | 'warning' | 'error'
  }) => {
    addNotification({
      title: notification.title,
      message: notification.message,
      type: notification.type || 'info',
      timestamp: new Date(),
      read: false
    })
  }

  return {
    toast,
    success: (title: string, message: string) => toast({ title, message, type: 'success' }),
    error: (title: string, message: string) => toast({ title, message, type: 'error' }),
    warning: (title: string, message: string) => toast({ title, message, type: 'warning' }),
    info: (title: string, message: string) => toast({ title, message, type: 'info' })
  }
}